module.exports = __webpack_public_path__ + "img/rescue.b41c2b9a.png";